import { AlertInfo } from 'common/graphqlTypes';
import { textToFilterValue } from 'common/util/string';

export const isTemplatedAlert = (alert: AlertInfo): boolean => alert.numAlertsInGroup > 1;

export const getNonTemplatedAlerts = (alerts: Array<AlertInfo>) => alerts.filter((alert) => !isTemplatedAlert(alert));

type templateParameters = {
  [key: string]: {
    chars: string;
    valueType: string;
    string: string;
  };
};

export const createMuteCondition = (templateParameters: templateParameters): string => {
  if (!templateParameters) {
    return '';
  }

  let result = '';
  let predicates = 0;

  // We need to create a filter expression, one term for each template parameter.
  for (let param in templateParameters) {
    if (templateParameters.hasOwnProperty(param)) {
      predicates++;
      // TODO: Remove check for object after verifying this would not break muting template alerts
      let value =
        typeof templateParameters[param] === 'object' ? templateParameters[param].string : templateParameters[param];
      // If it is a string, then handle it specially because we have to surround it in quotes and escape any
      // backslashes or double quotes.

      let predicate = `(${param} == ${typeof value === 'string' ? textToFilterValue(value) : value})`;
      result = result.length > 0 ? `${result} && ${predicate}` : predicate;
    }
  }

  // We strip off the parenthesis if it turns out this condition
  // only had one predicate.
  return predicates === 1 ? result.substring(1, result.length - 1) : result;
};
